<template>
  <el-dialog
    title="Cadastrar Pagamento de Comissão"
    :visible.sync="visibility"
    :before-close="fechar"
    :modal-append-to-body="false"
    @open="reset"
    width="30%"
  >
    <el-form size="small" label-position="top">
      <el-form-item label="Corretor" style="width: 100%">
        <el-input
          v-if="!comissao.comissaoImobiliaria"
          v-model="comissao.corretor.nome"
          style="width: 100%"
          readonly
        ></el-input>

        <el-input value="IMOBILIÁRIA" v-else readonly></el-input>
      </el-form-item>

      <el-row :span="24" :gutter="4">
      <el-col :span="8">
        <el-form-item label="Previsão de Pgto">
          <el-input v-model="dataPagamento" v-mask="'##/##/####'"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="Valor">
          <div class="el-input el-input--small">
            <money
              v-model="valor"
              v-bind="money"
              class="el-input__inner"
            />
          </div>
        </el-form-item>
      </el-col>

      <el-col :span="8">
        <el-form-item label="Parcelas">
          <el-input v-model="parcelas"></el-input>
        </el-form-item>
      </el-col>
      </el-row>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="fechar">Fechar</el-button>
      <el-button @click="adicionarPagamento" type="primary">Adicionar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { Money } from "v-money";
import Util from "../../util/funcoes.js";

export default {
  components: {
    Money
  },
  props: {
    visibility: Boolean,
    comissao: {
      corretor: {
        nome: ''
      }
    }
  },
  data() {
    return {
      dataPagamento: Util.hoje(),
      pagamentoComissao: {},
      parcelas: 1,
      valor: 0,

      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 2,
        masked: false
      }
    };
  },
  computed: {
    ...mapState("vendasStore", {
      venda(state) {
        return state.vendaSelecionada;
      },
      usuariosDisponiveis() {
        return this.$store.state.vendasStore.usuariosDisponiveis;
      }
    })
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("vendasStore", ["adicionarPagamentoComissao"]),
    adicionarPagamento() {
      this.pagamentoComissao = { 
        id: this.comissao.id,
        dataPrevisaoPagamento: this.dataPagamento,
        valorPago: this.valor,
        parcelas: this.parcelas,
        venda: { id: this.venda.id },
        comissao: { id: this.comissao.id },
        corretor: { id: this.comissao.corretor.id }
      };

      this.showLoading();
      this.adicionarPagamentoComissao(this.pagamentoComissao).then((response) => {
        this.hideLoading();
        switch(response.status) {
          case "SUCESSO":
            this.$message.success(response.mensagem);
            this.fechar();
            break;
          case "FALHA":
            this.$message.warning(response.mensagem);
            break;
          case "ERRO":
            this.$message.error(response.mensagem);
            break;
        }
      }).catch(() => {
        this.hideLoading();
      });
    },
    reset() {
      this.parcelas = 1;
      this.valor = 0;
    },
    fechar() {
      this.$emit("close");
    }
  }
};
</script>

